enum LoadsFilterLocationType {
    Source = 0,
    Destination = 1,
}

export default LoadsFilterLocationType;
